export default "__VITE_ASSET__DN8HJ69M__"